import { z } from "zod";

export const screener = z
  .object({
    bookmarkedIndicators: z.array(z.string()).default([]),
  })
  .default({
    bookmarkedIndicators: [],
  });
